import React from 'react';
import {DraggableEventHandler} from 'react-draggable';

import {
  availableLetter,
  availableLetterSpan,
  lettersContainer,
  remainingLetters,
  remainingLettersHighlighted,
} from '#Client/components/AvailableLetters/AvailableLetters.css';
import {Letter} from '#Client/components/Letter/Letter';

type AvailableLettersProps = {
  availableLetters: string[];
  onDragStop: () => void;
  getOnStart: (row: number, column: number, letter: string) => () => void;
  onDrag: DraggableEventHandler;
  droppingCoordinates: number[];
};

export const AvailableLetters = ({
  availableLetters,
  onDragStop,
  getOnStart,
  onDrag,
  droppingCoordinates,
}: AvailableLettersProps) => (
  <fieldset
    className={`${remainingLetters} ${
      droppingCoordinates[0] === -2 && droppingCoordinates[1] === -2
        ? remainingLettersHighlighted
        : ''
    }`}
    data-dropcontainer={true}
  >
    <legend>Available Letters</legend>
    <div className={lettersContainer} data-dropcontainer={true}>
      {availableLetters.map((letter, index) => {
        return (
          <div className={availableLetter} key={`${index}-${letter}`}>
            <Letter
              draggable
              letter={letter}
              letterClassname={availableLetterSpan}
              onDrag={onDrag}
              onStart={getOnStart(-1, -1, letter)}
              onStop={onDragStop}
            />
          </div>
        );
      })}
    </div>
  </fieldset>
);
